var _radialGradient, _path, _path2, _path3, _radialGradient2, _path4, _path5, _radialGradient3, _path6, _path7, _radialGradient4, _path8, _path9, _radialGradient5, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApprovalPack5 = function SvgApprovalPack5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "approval-pack5_svg__a",
    cx: 51.77,
    cy: 31.4,
    r: 87.04,
    gradientTransform: "matrix(-.00218 1 -.7873 -.00172 76.6 -20.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#approval-pack5_svg__a)",
    d: "M85.52 121.67c-8.63-.07-21.58-.41-34.32-1.61-8.77-.83-17.83-2.14-24.71-6.04-1.94-1.1-4.06-1.37-5.94-1.6-.8-.1-1.55-.19-2.19-.34a10.63 10.63 0 0 1-8.31-10.26l-.07-32.75a9.05 9.05 0 0 1 7.69-9.02l.23-.05c.55-.18 13.69-4.46 23.59-12.2a34.2 34.2 0 0 0 10.68-15c2.02-5.73 2.01-11.98 2-17 0-3.24-.01-7.27.87-7.86a12.56 12.56 0 0 1 7.01-2.13c7.72 0 15.6 7.05 15.91 14.23.22 4.98-1.45 10.86-3.06 16.54-1.9 6.73-3.55 12.54-2.06 16.49.22.59.78.97 1.4.97l7.29-.25h.07c8.16 0 14.8 6.64 14.81 14.79l.05 42.21c0 2.91-1.12 5.64-3.18 7.69a10.81 10.81 0 0 1-7.69 3.19h-.07z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA600",
    d: "M62.05 7.31c6.86 0 14.13 6.46 14.41 12.79.21 4.74-1.42 10.5-3 16.07-1.98 6.98-3.68 13.01-2.02 17.42a3 3 0 0 0 2.81 1.94h.11l7.2-.25h.06c7.33 0 13.3 5.96 13.31 13.3l.05 42.21c0 2.5-.97 4.86-2.74 6.63s-4.12 2.75-6.63 2.75h-.08c-8.6-.07-21.51-.41-34.19-1.6-8.6-.81-17.48-2.09-24.11-5.85-2.2-1.25-4.58-1.54-6.49-1.78-.76-.09-1.47-.18-2.03-.32a9.12 9.12 0 0 1-7.15-8.8l-.08-32.75a7.55 7.55 0 0 1 6.42-7.53c.15-.02.31-.06.45-.11.56-.18 13.94-4.55 24.05-12.45A35.8 35.8 0 0 0 53.57 33.3c2.11-5.97 2.1-12.36 2.09-17.5 0-2.44-.01-5.74.41-6.74a10.97 10.97 0 0 1 5.98-1.75m0-3c-2.65 0-5.33.72-7.84 2.38-3.24 2.14.27 15.02-3.46 25.6a32.64 32.64 0 0 1-10.19 14.32c-9.8 7.66-23.12 11.96-23.12 11.96a10.6 10.6 0 0 0-8.96 10.51l.08 32.75a12.13 12.13 0 0 0 9.46 11.71c2.22.52 5.25.38 7.73 1.79 6.63 3.76 15.13 5.26 25.31 6.22 12.6 1.19 25.4 1.54 34.45 1.62h.1c6.83 0 12.38-5.54 12.37-12.38l-.05-42.21a16.3 16.3 0 0 0-16.31-16.29h-.12l-7.24.25c-2.5-6.64 5.69-21.58 5.21-32.57-.35-7.81-8.68-15.66-17.42-15.66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA600",
    d: "M66.12 62.5c1.88 5 1.9 12.8 0 17.62-2.75 6.96-9.48 13.05-17.25 14.12-1.9.26-.77 2.01 1.12 1.75 8.41-1.16 19.79-4.57 22.75-12.12 8.12-20.75-1.38-31.62-5.62-28.38-2.04 1.58-2.06 4.18-1 7.01z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "approval-pack5_svg__b",
    cx: 2459.4,
    cy: -319.18,
    r: 20.33,
    gradientTransform: "matrix(-1.3883 .0794 -.0374 -.6794 3505.4 -353.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#approval-pack5_svg__b)",
    d: "M86.28 69.92c-8.36 0-18.41-1.55-18.84-8.96a6.97 6.97 0 0 1 1.96-5.43c3.79-4.02 13.1-6.23 26.22-6.23 4.76 0 8.23.31 8.27.31l.13.01h.09l.41-.01c4.25 0 7.8 3.83 8.09 8.72.3 5.06-3.03 9.38-7.42 9.63a.83.83 0 0 0-.22.03c-.09.01-9.35 1.93-18.69 1.93z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA600",
    d: "M95.63 50.8c4.68 0 8.1.3 8.13.3l.27.01.17-.01.32-.01c3.45 0 6.35 3.21 6.59 7.3a8.37 8.37 0 0 1-1.69 5.67 5.95 5.95 0 0 1-4.32 2.38c-.15.01-.3.03-.44.06-.09.02-9.22 1.91-18.38 1.91-5.32 0-9.54-.62-12.53-1.84-4.11-1.68-4.72-4.06-4.81-5.7-.1-1.71.4-3.08 1.56-4.32 3.45-3.65 12.61-5.75 25.13-5.75m0-3c-11.42 0-30.36 1.73-29.69 13.25.49 8.32 10.53 10.37 20.34 10.37 9.61 0 19-1.97 19-1.97 5.22-.31 9.18-5.33 8.83-11.22-.33-5.7-4.57-10.13-9.58-10.13l-.5.01s-3.51-.31-8.4-.31z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "approval-pack5_svg__c",
    cx: 2557.2,
    cy: -508.52,
    r: 18.75,
    gradientTransform: "matrix(-1.6967 -.00188 .00291 -.6804 4447.7 -263.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#approval-pack5_svg__c)",
    d: "M92.55 88.95c-10.91 0-23.91-1.83-23.91-10.57s13-10.57 23.91-10.57c9.25 0 17.68 1.35 17.76 1.36l.24.02c4.41 0 7.48 4.66 7.48 8.84 0 4.41-3.27 9.53-7.48 9.53l-.24.02c-.09.02-8.52 1.37-17.76 1.37z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA600",
    d: "M92.55 69.32c9.12 0 17.44 1.33 17.52 1.34.16.03.32.04.48.04 3.42 0 5.98 3.88 5.98 7.34 0 3.61-2.76 8.03-5.98 8.03-.16 0-.32.01-.48.04-.08.01-8.41 1.34-17.52 1.34-6.83 0-12.26-.72-16.15-2.15-5.61-2.06-6.26-4.94-6.26-6.92 0-1.99.65-4.86 6.26-6.92 3.88-1.42 9.32-2.14 16.15-2.14m0-3c-11.93 0-25.41 2.19-25.41 12.07s13.47 12.07 25.41 12.07c9.49 0 18-1.38 18-1.38 5.16 0 8.98-5.91 8.98-11.03s-3.82-10.34-8.98-10.34c0-.01-8.52-1.39-18-1.39z"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "approval-pack5_svg__d",
    cx: 2601.3,
    cy: -320.21,
    r: 20.45,
    gradientTransform: "matrix(-1.3069 -.00626 .00452 -.6804 3502.3 -89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#approval-pack5_svg__d)",
    d: "M100.86 122.19c-4.21 0-25.54-.33-32-6.8a5.12 5.12 0 0 1-1.67-3.73c.02-5.25 9.01-8.26 24.66-8.26 5.58 0 9.9.4 9.95.4l.13.01c2.34.01 4.55.96 6.2 2.69a9.36 9.36 0 0 1 2.58 6.52c-.02 5.05-3.97 9.15-8.81 9.15-.07.02-.42.02-1.04.02z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA600",
    d: "M91.86 104.91c5.49 0 9.76.39 9.8.4l.27.01a7.1 7.1 0 0 1 5.12 2.23 7.82 7.82 0 0 1 2.16 5.48c-.01 4.22-3.29 7.66-7.34 7.66h-.07l-.95.01c-18.15 0-28.01-3.43-30.94-6.36-1.11-1.11-1.23-2.05-1.23-2.66.03-4.18 8.9-6.77 23.18-6.77m0-3c-10.72 0-26.14 1.44-26.16 9.75-.04 11.46 29.3 12.03 35.16 12.03l1.01-.01h.03c5.68 0 10.29-4.76 10.31-10.65.02-5.9-4.58-10.7-10.27-10.72 0 .01-4.37-.4-10.08-.4z"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "approval-pack5_svg__e",
    cx: 2578.2,
    cy: -485.68,
    r: 18.61,
    gradientTransform: "matrix(-1.6358 -.00188 .0028 -.6804 4323.8 -229.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#approval-pack5_svg__e)",
    d: "M97.12 106.32c-8.99 0-29.89-1.02-29.89-10.47 0-7.94 15.07-9.12 24.06-9.12 7.95 0 14.8.88 14.87.89l.19.01c4.17 0 9.03 2.06 9.03 7.87 0 5.5-4.3 10.5-9.03 10.5h-.12c-.04.01-3.89.32-9.11.32z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA600",
    d: "M91.29 85.24v3c7.83 0 14.61.87 14.67.88.13.02.26.02.39.02 3.64 0 7.53 1.67 7.53 6.37 0 4.63-3.66 9-7.53 9l-.25.01c-.04 0-3.83.31-8.99.31-5.45 0-13.24-.35-19.41-1.99-5.95-1.59-8.97-3.94-8.97-6.97 0-.93 0-3.76 6.34-5.75 3.95-1.24 9.4-1.87 16.21-1.87l.01-3.01m0 0c-11.56 0-25.56 1.82-25.56 10.62 0 10.37 19.4 11.97 31.39 11.97 5.36 0 9.23-.32 9.23-.32 5.64 0 10.53-5.83 10.53-12s-4.89-9.37-10.53-9.37c0 0-6.93-.9-15.06-.9zm-63.5 29.66L23 96l-2 17z"
  })));
};
export default SvgApprovalPack5;